<template>
  <article :class="{ 'category-selector': true, 'align-center': initial }">
    <header v-stack-x:sm>
      <h2 v-if="initial">{{ 'Add your first product to get started!' | t }}</h2>
      <h2 v-else>{{ 'Add a Product' | t }}</h2>
      <p v-if="initial">{{ 'Click "Add to DesignSpec" on any product page to start your DesignSpec project.' | t }}</p>
      <p v-else>{{ 'Choose a product category to browse.' | t }}</p>
    </header>
    <ul class="categories">
      <li v-for="category in categories">
        <category-card :url="category.url">
          {{ category.label }}
        </category-card>
      </li>
    </ul>
  </article>
</template>

<script>
import {mapGetters} from 'vuex';
import CategoryCard from './CategoryCard.vue';
import t from '../../main/i18n';

const categories = [
  {url: '/commercial-bathroom-products/smart-products', label: t('Smart Products')},
  {url: '/commercial-bathroom-products/flushometers/browse', label: t('Flushometers')},
  {url: '/commercial-bathroom-products/faucets/browse', label: t('Faucets')},
  {url: '/commercial-bathroom-products/soap-dispensers/browse', label: t('Soap Dispensers')},
  {url: '/commercial-bathroom-products/sinks/browse', label: t('Sinks')},
  {url: '/commercial-bathroom-products/fixtures', label: t('Fixtures')},
  {url: '/commercial-bathroom-products/mirrors/browse', label: t('Mirrors')},
  {url: '/commercial-bathroom-products/hand-dryers/browse', label: t('Hand Dryers')},
  {url: '/commercial-bathroom-products/water-saving-shower-heads/browse', label: t('Showerheads')}
];

export default {
  props: {
    initial: {type: Boolean, default: false}
  },
  filters: {
    t
  },
  data() {
    return {categories};
  },
  computed: mapGetters('designspec', ['projectName']),
  components: {CategoryCard}
};
</script>

<style lang="scss" scoped>
@import '../../../scss/variables';
@import '../../../scss/system';

.category-selector {
  margin-bottom: 32px;
}

.align-center {
  header {
    flex-direction: column;
    justify-content: center;
    text-align: center;

    h2,
    p {
      margin-left: auto !important;
      margin-right: auto !important;
    }

    p {
      margin-top: 4px;
    }
  }
}

header {
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  margin-bottom: 16px;

  h2 {
    @include text('lg', 'strong');
  }

  p {
    @include text('sm');
    color: $color-gray-700;
  }
}

.categories,
.categories li {
  margin: 0;
  padding: 0;
  list-style: none;
}

.categories {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
</style>
